import OTdetailsService from "../service/OTdetailsServices";

export const fetchOTDetails = (date,serviceNo ) => async dispatch => {
  dispatch({ type: "FETCH_OTDETAILS_REQUEST" });
  try {    
    const response = await OTdetailsService.getAssignOT(date, serviceNo);
    dispatch({ type: "FETCH_OTDETAILS_SUCCESS", payload: response.data.JobsList  });
  } catch (error) {
    console.error("Error fetching attendance data:", error);
    dispatch({ type: "FETCH_OTDETAILS_FAILURE" });
  }
};

// export const fetchOT1Details = (date,serviceNo ) => async dispatch => {
//   dispatch({ type: "FETCH_OTDETAILS1_REQUEST" });
//   try {    
//     const response = await OTdetailsService.get(
//       `attme/GetAssignOTDetails?date=${date}&serviceNo=${serviceNo}`
//     );
//     dispatch({ type: "FETCH_OTDETAILS1_SUCCESS", payload: response.data.JobsList  });
//   } catch (error) {
//     console.error("Error fetching attendance data:", error);
//     dispatch({ type: "FETCH_OTDETAILS1_FAILURE" });
//   }
// };